import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast'; // Import Toaster
import HeaderV2 from './components/Header-v2'; // Use the new V2 Header
import FooterV2 from './components/FooterV2'; // Import the new V2 Footer
// import Footer from './components/Footer'; // Old Footer - V2 Home has its own
import HomeV2 from './pages/home-v2'; // New Homepage
import Contests from './pages/contests-list/Contests';
import RegisteringContests from './pages/contests-list/RegisteringContests';
import RunningContests from './pages/contests-list/RunningContests';
import CompletedContests from './pages/contests-list/CompletedContests';
import DraftPage from './pages/contests/draft/DraftPage';
import HowItWorks from './pages/howitworks/HowItWorks';
import Rules from './pages/rules/Rules';
import Account from './pages/account/Account';
import Support from './pages/support/Support';
import PageNotFound from './pages/PageNotFound';
import ContestInfoRegistering from './pages/contests/registering/ContestInfoRegistering';
import ContestInfoRunning from './pages/contests/running/ContestInfoRunning';
import ContestInfoCompleted from './pages/contests/completed/ContestInfoCompleted';
import Login from './pages/login/Login';
import SignUp from './pages/signup/SignUp';
import { AuthProvider } from './context/AuthContext';
import SnakeDraftPage from './pages/contests/draft/SnakeDraftPage'; // Import the new preview page

function App() {
  // const location = useLocation(); // No longer needed for header/footer logic here
  // const isNewHomepage = location.pathname === '/'; // No longer needed

  return (
    <AuthProvider> 
      <Toaster 
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          // Define default options
          duration: 5000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
      <div className="App">
        <HeaderV2 /> {/* Render new V2 Header on all pages */}
        <Routes>
          <Route path="/" element={<HomeV2 />} />
          <Route path="/contests" element={<Contests />}>
            <Route path="registering" element={<RegisteringContests />} />
            <Route path="running" element={<RunningContests />} />
            <Route path="completed" element={<CompletedContests />} />
          </Route>
          <Route path="/draft/:id" element={<DraftPage />} /> 
          <Route path="/snake-draft-preview" element={<SnakeDraftPage />} /> {/* Add temporary route */}
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/account" element={<Account />} />
          <Route path="/rules" element={<Rules />} />
          <Route path="/support" element={<Support />} />
          <Route path="/contests/registering/:id" element={<ContestInfoRegistering />} />
          <Route path="/contests/running/:id" element={<ContestInfoRunning />} />
          <Route path="/contests/completed/:id" element={<ContestInfoCompleted />} />
          <Route path="/login" element={<Login />} /> 
          <Route path="/signup" element={<SignUp />} /> 
          <Route path="*" element={<PageNotFound />} />
        </Routes>
        <FooterV2 />
      </div>
    </AuthProvider>
  );
}

export default App;
